export enum EnvironmentPrefixEnum {
    Pml = 'pml',
    Pvl = 'pvl',
    PmlDev = 'pmldev',
    PvlDev = 'pvldev',
    PmlDevUk = 'pmldevuk',
    PvlDevUk = 'pvldevuk',
    PmlUat = 'pmluat',
    PvlUat = 'pvluat'
  }
